/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import DPRSettingsPipelinesTab from './DPR/DPRSettingsPipelinesTab';
import AddPQTReportModal from './AddPQTReportModal';
import {
  fetchPqtElements,
  fetchProjectPqtReport,
  updateProjectPqtReport,
  createProjectPqtReport,
  createPqtElement,
} from '../redux/projectPqtReports/actions';
import { fetchSowDetails } from '../redux/sowDetails/actions';

const Details = (props) => {
  const {
    selectedProject,
    projectTeamMembersAccessList,
    userAccessList,
    pqtElements,
    pqtReport,
    isPqtReportLoading,
    isReportFetching,
    onFetchPqtElements,
    onFetchProjectPqtReport,
    onUpdateProjectPqtReport,
    onCreateProjectPqtReport,
    onCreatePqtElement,
    onFetchSowDetails,
  } = props;

  const [isPqtReportModalVisible, setIsPqtReportModalVisible] = useState(false);

  useEffect(() => {
    const projId = get(selectedProject, 'id', undefined);
    if (projId) {
      onFetchPqtElements();
      onFetchProjectPqtReport(projId);
      onFetchSowDetails(projId);
    }
  }, [selectedProject?.id, onFetchPqtElements, onFetchProjectPqtReport, onFetchSowDetails]);

  //details write access control for normal user
  const isButtonDisabled = () => {
    const groups = Array.isArray(userAccessList) ? userAccessList : [];
    if (groups.includes('admin') || groups.includes('super-admin')) return false;
    if (projectTeamMembersAccessList[0]?.isGuestUser) {
      return true;
    }
    const member = projectTeamMembersAccessList[0];
    const detailsWrite = member?.tabPermissions?.Details?.write;
    // Only treat as read-only when the API explicitly denies Details write.
    // Missing `tabPermissions` must not disable actions (undefined !== false).
    if (member?.isNormalUser && detailsWrite === false) {
      return true;
    }
    return false;
  };
  /** Misnamed in legacy code: `true` means read-only / actions blocked (no Details write). */
  const isWriteAccess = isButtonDisabled();

  const formatDetailValue = (value) => {
    if (value == null) return '—';
    const text = String(value).trim();
    return text || '—';
  };

  const openPqtReportModal = () => {
    if (isWriteAccess) return;
    const id = get(selectedProject, 'id', undefined);
    if (!id) return;
    if (!pqtElements?.length) onFetchPqtElements();
    onFetchProjectPqtReport(id);
    setIsPqtReportModalVisible(true);
  };

  const handleSavePqtReport = async (payload) => {
    const projectId = get(selectedProject, 'id', undefined);
    if (payload.reportId) {
      await onUpdateProjectPqtReport({
        reportId: payload.reportId,
        name: payload.name,
        description: payload.description,
        elements: payload.elements,
      });
    } else {
      await onCreateProjectPqtReport({
        projectId,
        name: payload.name,
        description: payload.description,
        elements: payload.elements,
      });
    }
    setTimeout(() => {
      if (projectId) {
        onFetchProjectPqtReport(projectId);
      }
      setIsPqtReportModalVisible(false);
    }, 1500);
  };

  return (
    <div className="d-flex h-100">
      <div
        className="overflow-auto"
        style={{ flex: 1, paddingRight: '24px', display: 'flex', flexDirection: 'column' }}
      >
        <DPRSettingsPipelinesTab
          selectedProject={selectedProject}
          onAddPqtActivities={openPqtReportModal}
          addPqtActivitiesDisabled={isWriteAccess}
        />
      </div>

      <AddPQTReportModal
        visible={isPqtReportModalVisible}
        onCancel={() => setIsPqtReportModalVisible(false)}
        onSave={handleSavePqtReport}
        pqtElements={pqtElements}
        existingReport={pqtReport}
        loading={isPqtReportLoading}
        isReportFetching={isReportFetching}
        isWriteAccess={isWriteAccess}
        onCreatePqtElement={onCreatePqtElement}
      />

      <div
        className="overflow-hidden"
        style={{ flex: '0 0 280px' }}
      >
        <div className="d-flex flex-column h-100">
          <div className="flex-auto">
            <div className="d-flex mb-3 ps-3 align-items-center tab-content-title">
              <div
                className="mb-0 text-dark"
                style={{ color: '#1F2937', fontWeight: 600, fontSize: '18px', margin: 0 }}
              >
                Other Details
              </div>
            </div>
            <div style={{ height: '1px', backgroundColor: '#e5e7eb', width: '100%', marginBottom: '16px', marginLeft: '16px' }} />
          </div>

          <div className="flex-fill">
            <div className="d-flex flex-column h-100">
              <div className="flex-auto overflow-hidden">
                <div className="py-3 px-3">
                  <div style={{
                    background: '#FFFFFF',
                    borderRadius: '8px',
                    padding: '16px',
                    border: '1px solid #E5E7EB',
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                  }}>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'minmax(110px, auto) 1fr',
                      gap: '12px',
                      fontSize: '13px',
                    }}>
                      <div style={{ fontWeight: 500, color: '#6B7280' }}>Contract #</div>
                      <div style={{ fontWeight: 600, color: '#1F2937' }}>
                        {formatDetailValue(selectedProject?.contractId)}
                      </div>

                      <div style={{ fontWeight: 500, color: '#6B7280' }}>CRCE Ref #</div>
                      <div style={{ fontWeight: 600, color: '#1F2937' }}>
                        {formatDetailValue(selectedProject?.pihRefId)}
                      </div>

                      <div style={{ fontWeight: 500, color: '#6B7280' }}>Contractor</div>
                      <div style={{ fontWeight: 600, color: '#1F2937' }}>
                        {formatDetailValue(selectedProject?.contractor)}
                      </div>

                      <div style={{ fontWeight: 500, color: '#6B7280' }}>Contract Client</div>
                      <div style={{ fontWeight: 600, color: '#1F2937' }}>
                        {formatDetailValue(selectedProject?.clientName)}
                      </div>

                      <div style={{ fontWeight: 500, color: '#6B7280' }}>Final Client</div>
                      <div style={{ fontWeight: 600, color: '#1F2937' }}>
                        {formatDetailValue(selectedProject?.finalClient)}
                      </div>

                      <div style={{ fontWeight: 500, color: '#6B7280' }}>Location</div>
                      <div style={{ fontWeight: 600, color: '#1F2937' }}>
                        {formatDetailValue(selectedProject?.location)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ equip, projectPqtReportsReducer }) => {
  const projectTeamMembersAccessList = get(equip, 'projectTeamMembersAccessList', []);
  const userAccessList = get(equip, 'userAccessList', []);
  const pqtElements = get(projectPqtReportsReducer, 'pqtElements', []);
  const pqtReport = get(projectPqtReportsReducer, 'report', null);
  const isPqtReportLoading = get(projectPqtReportsReducer, 'isUpdateLoading', false);
  const isReportFetching = get(projectPqtReportsReducer, 'isReportLoading', false);
  return {
    projectTeamMembersAccessList,
    userAccessList,
    pqtElements,
    pqtReport,
    isPqtReportLoading,
    isReportFetching,
  };
};

const mapDispatchToProps = {
  onFetchPqtElements: fetchPqtElements,
  onFetchProjectPqtReport: fetchProjectPqtReport,
  onUpdateProjectPqtReport: updateProjectPqtReport,
  onCreateProjectPqtReport: createProjectPqtReport,
  onCreatePqtElement: createPqtElement,
  onFetchSowDetails: fetchSowDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(Details);
